import React from 'react';
import styled from 'styled-components';
import {
  Box,
  Button,
  Modal,
  Text as BaseText,
} from '@rsos/components/capstone/base';
import {
  ModalBody,
  ModalHeader,
  ModalFooter,
} from '@rsos/components/capstone/base/Modal/ModalComponents';

const MODAL_WIDTH = 433;

const Text = styled(BaseText).attrs({
  color: 'primaryText',
})``;

const AviveCancelModal = ({
  isOpened,
  onClose = () => {},
  onConfirm = () => {},
}) => {
  return (
    <Modal
      id="avive-cancel-modal"
      isOpened={isOpened}
      onClose={onClose}
      width={MODAL_WIDTH}
    >
      <ModalHeader onClose={onClose}>
        <Box>
          <Text size="xlarge">
            Are you sure want to <br />{' '}
            <strong>cancel the AED Dispatch?</strong>
          </Text>
        </Box>
      </ModalHeader>
      <ModalBody>
        <Box>
          <Text size="small">
            This will send a message to all AEDs to dismiss the request. You
            will no longer see the markers on the map.
          </Text>
        </Box>
      </ModalBody>
      <ModalFooter flow={12}>
        <Button btnType="secondary" onClick={onClose}>
          No, Retain Request
        </Button>
        <Button btnType="primary" onClick={onConfirm}>
          Yes, Cancel Request
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AviveCancelModal;
